import { useEffect, useState } from "react";
import { Phone, MessageSquare, X } from "lucide-react";
import { BRAND } from "../lib/constants";

export default function StickyCTA() {
  const [scrolled, setScrolled] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goContact = () => {
    if (window.location.pathname === "/") {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/#contact";
    }
  };

  if (dismissed) return null;

  return (
    <>
      {/* Mobile: persistent bottom bar after scroll */}
      <div
        data-testid="sticky-cta-mobile"
        className={`md:hidden fixed bottom-0 inset-x-0 z-40 transition-transform duration-300 ${
          scrolled ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div className="bg-white border-t border-[#E5DDC9] shadow-[0_-8px_24px_-12px_rgba(0,81,101,0.2)] p-3 grid grid-cols-2 gap-2">
          <a
            href={`tel:${BRAND.phoneRaw}`}
            data-testid="sticky-call-btn"
            className="flex items-center justify-center gap-2 bg-[#AC9667] hover:bg-[#7A6A48] text-white rounded-full h-12 transition-colors btn-shimmer"
          >
            <Phone className="w-4 h-4" /> <span className="text-sm font-medium">Call Now</span>
          </a>
          <button
            onClick={goContact}
            data-testid="sticky-msg-btn"
            className="flex items-center justify-center gap-2 bg-[#005165] hover:bg-[#003946] text-white rounded-full h-12 transition-colors"
          >
            <MessageSquare className="w-4 h-4" /> <span className="text-sm font-medium">Schedule</span>
          </button>
        </div>
      </div>

      {/* Desktop: floating pills bottom-right */}
      <div
        data-testid="sticky-cta-desktop"
        className={`hidden md:flex fixed right-5 bottom-5 z-40 flex-col items-end gap-2 transition-all duration-500 ${
          scrolled ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="w-7 h-7 rounded-full bg-white border border-[#E5DDC9] flex items-center justify-center text-[#4B5563] hover:text-[#005165] -mb-1 self-end shadow"
        >
          <X className="w-3 h-3" />
        </button>
        <a
          href={`tel:${BRAND.phoneRaw}`}
          data-testid="sticky-call-btn-desktop"
          className="flex items-center gap-2 bg-[#AC9667] hover:bg-[#7A6A48] text-white rounded-full px-5 h-12 shadow-2xl border border-white/20 transition-colors btn-shimmer"
        >
          <Phone className="w-4 h-4" /> <span className="text-sm font-medium">Call {BRAND.phone}</span>
        </a>
        <button
          onClick={goContact}
          data-testid="sticky-msg-btn-desktop"
          className="flex items-center gap-2 bg-[#005165] hover:bg-[#003946] text-white rounded-full px-5 h-12 shadow-2xl border border-white/10 transition-colors"
        >
          <MessageSquare className="w-4 h-4" /> <span className="text-sm font-medium">Schedule Consultation</span>
        </button>
      </div>
    </>
  );
}
